import { create } from "zustand";
import type { Plan, PlanState, CheckoutResponse, BillingPortalResponse } from "../types";
import { plansApi } from "../services/plan-api";

export const usePlanStore = create<PlanState>((set) => ({
	plans: null,
	isLoading: false,
	isCheckoutLoading: false,
	isPortalLoading: false,
	error: null,

	index: async (): Promise<Plan[] | null> => {
		set({ isLoading: true, error: null });
		try {
			const result = await plansApi.index();
			if (result.success && result.data) {
				set({ plans: result.data, isLoading: false });
				return result.data;
			} else {
				set({ error: result.error || "Failed to fetch plans", isLoading: false });
				return null;
			}
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : "Failed to fetch plans";
			set({ error: errorMessage, isLoading: false });
			return null;
		}
	},

	createCheckout: async (workspaceId: string, planId?: string): Promise<CheckoutResponse | null> => {
		set({ isCheckoutLoading: true, error: null });
		try {
			const result = await plansApi.createCheckout(workspaceId, planId);
			if (result.success && result.data) {
				set({ isCheckoutLoading: false });
				return result.data;
			} else {
				set({ error: result.error || "Failed to create checkout session", isCheckoutLoading: false });
				return null;
			}
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : "Failed to create checkout session";
			set({ error: errorMessage, isCheckoutLoading: false });
			return null;
		}
	},

	getBillingPortal: async (workspaceId: string): Promise<BillingPortalResponse | null> => {
		set({ isPortalLoading: true, error: null });
		try {
			const result = await plansApi.getBillingPortal(workspaceId);
			if (result.success && result.data) {
				set({ isPortalLoading: false });
				return result.data;
			} else {
				set({ error: result.error || "Failed to get billing portal", isPortalLoading: false });
				return null;
			}
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : "Failed to get billing portal";
			set({ error: errorMessage, isPortalLoading: false });
			return null;
		}
	},
}));
